// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Person20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Person20Filled: FC<Person20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <mask
                id="a"
                width="20"
                height="20"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
                style={{ maskType: 'alpha' }}
            >
                <path d="M0 0h20v20H0z" />
            </mask>
            <g mask="url(#a)">
                <path d="M10 10a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 7 7c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 10 4c.833 0 1.542.292 2.125.875S13 6.167 13 7s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 10 10Zm-6 6v-2c0-.32.087-.621.26-.906a2.22 2.22 0 0 1 .72-.719 10.222 10.222 0 0 1 2.426-1.02 9.693 9.693 0 0 1 5.188 0c.854.235 1.663.576 2.427 1.02.305.18.545.417.719.708.173.292.26.598.26.917v2H4Z" />
            </g>
        </svg>
    );
};

export default Person20Filled;
